export { default as SectionFeatured } from './SectionFeatured/SectionFeatured';
export { default as SectionFeaturedBottom } from './SectionFeaturedBottom/SectionFeaturedBottom';
export { default as SectionFeaturedContent } from './SectionFeaturedContent/SectionFeaturedContent';
